module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "user-center"
  }, [_c('m-header'), _vm._v(" "), _c('div', {
    staticClass: "back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "icon-back"
  })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$route.params.id))]), _vm._v(" "), _c('div', {
    staticClass: "switches-wrapper"
  }, [_c('switches', {
    attrs: {
      "switches": _vm.switches,
      "currentIndex": _vm.currentIndex
    },
    on: {
      "switch": _vm.switchItem
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "listWrapper",
    staticClass: "list-wrapper"
  }, [(_vm.currentIndex === 0) ? _c('scroll', {
    ref: "favoriteList",
    staticClass: "list-scroll",
    attrs: {
      "data": _vm.favoriteList
    }
  }, [_c('div', {
    staticClass: "list-inner"
  }, [_c('song-list', {
    attrs: {
      "songs": _vm.favoriteList
    },
    on: {
      "select": _vm.selectSong
    }
  })], 1)]) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02ed28be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-center/user-center.vue
// module id = 560
// module chunks = 1